import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-marketing',
    templateUrl: './marketing.component.html',
    styleUrls: ['./marketing.component.scss'],
    standalone: false
})
export class MarketingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
